<!-- // welcome section \\ -->
<section class="welcome-section">
    <!-- <app-getcard></app-getcard> -->
    <div class="comman-width pricingSearch">
      <div class="welcome-center">
        <!-- search start -->
        <div class="search-fields">
          <app-search></app-search>
        </div>
        <!-- search end -->
        </div>
    </div>
  </section>
  <!-- \\ welcome section // -->
<!-- <app-getcard></app-getcard> -->
